import { render } from "./NotificationSystem.vue?vue&type=template&id=038f5991"
import script from "./NotificationSystem.vue?vue&type=script&lang=js"
export * from "./NotificationSystem.vue?vue&type=script&lang=js"

import "./NotificationSystem.vue?vue&type=style&index=0&id=038f5991&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__